<template>
    <b-collapse 
        animation="slide"
        :open="false"
    >
        <template #trigger="props">
            <div :class="[
                'card-header', 
                isChild ? 'bg-white mr-2' : 'bg-gray'
            ]">
                <a v-if="location.children" class="card-header-icon">
                    <span class="icon">
                        <i :class="props.open ? 'fas fa-angle-up' : 'fas fa-angle-down'"></i>
                    </span>
                </a>
                <span v-else class="card-header-icon">
                    <span class="icon">
                        <i class="fas fa-warehouse" />
                    </span>
                </span>
                <p class="card-header-title mb-0">
                    {{ location.name }}
                </p>
                <span 
                    class="card-header-icon"
                    :style="`margin-right: ${isChild ? '-0.5rem' : ''}`"
                >
                    <span class="icon" @click.stop="newLocation">
                        <i class="fas fa-plus" />
                    </span>
                    <span class="icon" @click.stop="editLocation">
                        <i class="fas fa-edit" />
                    </span>
                </span>
            </div>
        </template>

        <div 
            v-if="location.children?.length > 0" 
            :class="[
                'pl-4 pt-2 bg-gray',
                {'pb-2': !isChild}
            ]"
        >
            <div class="is-flex flex-col gap-2">
                <CollapsibleLocation 
                    v-for="child in location.children" 
                    :key="child.id" 
                    :location="child"
                    :is-child="true"
                    @edit-location="$emit('edit-location', $event)"
                    @new-location="$emit('new-location', $event)"
                />
            </div>
        </div>
    </b-collapse>
</template>

<script>
export default {
    name: 'CollapsibleLocation',
    props: {
        location: Object,
        isChild: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        editLocation() {
            this.$emit('edit-location', this.location);
        },
        newLocation() {
            this.$emit('new-location', this.location);
        }
    }
}
</script>

<style lang="scss" scoped>
.card-header {
    box-shadow: none;
    border-radius: 0;
}
</style>